<template>
  <basic-container>
    <Header></Header>
    <Table></Table>
  </basic-container>
</template>

<script>
import Vue from "vue";
import Header from "./components/Header.vue";
import Table from "./components/Table.vue";
import { getActiveGoodsLocalList, getActiveMemberList, getUniteGoodsList, getActiveGoodsOnlineList } from '@/api/memberNew/activeGoods'
export default {
  name: "WebSaaSIndex",
  components: {
    Header,
    Table,
  },
  provide() {
    return {
      /** 当前标签页 */
      currentTab: this.currentTab,
      /** 设置当前标签 */
      setTab: this.setTab,
      /** 搜索参数 */
      searchParams: this.searchParams,
      /** 分页列表 */
      list: this.list,
      /** 获取分页的方法 */
      getList: this.getList,
      /** 激活码会员 */
      cdkeyMemberList: this.cdkeyMemberList,
      /** 联运商品 */
      unionGoodsList: this.unionGoodsList,
    };
  },
  created() {
    Promise.all([this.getCdkeyMemberList(), this.getUnionGoodsList(), this.getList()])
  },
  data() {
    return {
      /** 当前标签页 */
      currentTab: Vue.observable({
        value: "local",
      }),
      /** 搜索参数 */
      searchParams: Vue.observable({
        /** 激活码名称 */
        cdkeyName: "",
        /** 激活码会员 */
        cdkeyMemberId: "",
        /** 状态 */
        status: "",
        current: 1,
        size: 10,
        total: 0,
      }),
      /** 列表 */
      list: Vue.observable({
        value: [
        ],
      }),
      /** 激活码会员列表 */
      cdkeyMemberList: Vue.observable({
        value: [],

      }),
      /** 联运商品 */
      unionGoodsList: Vue.observable({
        value: [],
      }),
    };

  },

  methods: {
    /** 设置标签页 */
    setTab(tab) {
      this.currentTab.value = tab;
    },
    /** 获取列表数据*/
    async getList() {
      if (this.currentTab.value === "local") {
        /** 本地数据 */
        this.getLocalList();
        console.log("获取本地数据");
      } else {
        /** 线上数据 */
        this.getOnlineList();
        console.log("获取线上数据");
      }

    },
    /** 获取本地数据 */
    async getLocalList() {
      const { data } = await getActiveGoodsLocalList(this.searchParams);
      console.log('获取本地数据的响应', data);
      this.list.value = data.data.records
      this.searchParams.total = data.data.total
    },
    /** 获取线上数据 */
    async getOnlineList() {
      const { data } = await getActiveGoodsOnlineList(this.searchParams);
      console.log('获取线上数据的响应', data);
      this.list.value = data.data.records
      this.searchParams.total = data.data.total
    },
    //^ ^--------------初始化数据-------------^ ^
    /** 获取激活码会员列表的数据 */
    async getCdkeyMemberList() {
      const { data } = await getActiveMemberList();
      console.log('获取激活码会员列表的数据', data);
      data.forEach(item => {
        item.id = Number(item.id)

      })
      this.cdkeyMemberList.value = data
    },
    /** 获取联合会员商品列表 */
    async getUnionGoodsList() {
      const { data } = await getUniteGoodsList();
      console.log('获取联合会员商品列表', data);
      data.data.unshift({
        id: 0,
        goodsName: "无",

      })
      data.data.forEach(item => {
        item.id = Number(item.id)
      });
      this.unionGoodsList.value = data.data
    },
  },
};
</script>

<style lang="scss" scoped></style>